export enum StorageType {
  LOCAL = 'local',
  SESSION = 'session',
}

export enum SessionKeys {
  USER = 'user',
}
